// Auth
export const REGISTER_USER_REQUEST = "auth/REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "auth/REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "auth/REGISTER_USER_FAILURE";

export const LOGIN_USER_REQUEST = "auth/LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "auth/LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "auth/LOGIN_USER_FAILURE";


export const UPDATE_LOGIN_USER = "auth/UPDATE_LOGIN_USER";

export const EMAIL_VERIFIED_SUCCESS = "auth/EMAIL_VERIFIED_SUCCESS";

export const LOGOUT_USER_REQUEST = "auth/LOGOUT_USER_REQUEST";

// Club
export const FETCH_ALL_CLUBS_REQUEST = "club/FETCH_ALL_CLUBS_REQUEST";
export const FETCH_ALL_CLUBS_SUCCESS = "club/FETCH_ALL_CLUBS_SUCCESS";
export const FETCH_ALL_CLUBS_FAILURE = "club/FETCH_ALL_CLUBS_FAILURE";

export const CREATE_CLUB_REQUEST = "club/CREATE_CLUB_REQUEST";
export const CREATE_CLUB_SUCCESS = "club/CREATE_CLUB_SUCCESS";
export const CREATE_CLUB_FAILURE = "club/CREATE_CLUB_FAILURE";

export const EDIT_CLUB_REQUEST = "club/EDIT_CLUB_REQUEST";
export const EDIT_CLUB_SUCCESS = "club/EDIT_CLUB_SUCCESS";
export const EDIT_CLUB_FAILURE = "club/EDIT_CLUB_FAILURE";

export const DELETE_CLUB_REQUEST = "club/DELETE_CLUB_REQUEST";
export const DELETE_CLUB_SUCCESS = "club/DELETE_CLUB_SUCCESS";
export const DELETE_CLUB_FAILURE = "club/DELETE_CLUB_FAILURE";


// Market
export const CREATE_CATEGORY_REQUEST = "market/CREATE_CATEGORY_REQUEST";
export const CREATE_CATEGORY_SUCCESS = "market/CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_FAILURE = "market/CREATE_CATEGORY_FAILURE";

export const EDIT_CATEGORY_REQUEST = "market/EDIT_CATEGORY_REQUEST";
export const EDIT_CATEGORY_SUCCESS = "market/EDIT_CATEGORY_SUCCESS";
export const EDIT_CATEGORY_FAILURE = "market/EDIT_CATEGORY_FAILURE";

export const CREATE_PRODUCT_REQUEST = "market/CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "market/CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAILURE = "market/CREATE_PRODUCT_FAILURE";

export const GET_ORDER_REQUEST = "market/GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "market/GET_ORDER_SUCCESS";
export const GET_ORDER_FAILURE = "market/GET_ORDER_FAILURE";


export const EDIT_PRODUCT_REQUEST = "market/EDIT_PRODUCT_REQUEST";
export const EDIT_PRODUCT_SUCCESS = "market/EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILURE = "market/EDIT_PRODUCT_FAILURE";

export const REMOVE_CATEGORY_REQUEST = "market/REMOVE_CATEGORY_REQUEST";
export const REMOVE_CATEGORY_SUCCESS = "market/REMOVE_CATEGORY_SUCCESS";
export const REMOVE_CATEGORY_FAILURE = "market/REMOVE_CATEGORY_FAILURE";

export const BUY_PRODUCT_REQUEST = "market/BUY_PRODUCT_REQUEST";
export const BUY_PRODUCT_SUCCESS = "market/BUY_PRODUCT_SUCCESS";
export const BUY_PRODUCT_FAILURE = "market/BUY_PRODUCT_FAILURE";


export const REMOVE_PRODUCT_REQUEST = "market/REMOVE_PRODUCT_REQUEST";
export const REMOVE_PRODUCT_SUCCESS = "market/REMOVE_PRODUCT_SUCCESS";
export const REMOVE_PRODUCT_FAILURE = "market/REMOVE_PRODUCT_FAILURE";

export const FETCH_ALL_PRODUCTS_REQUEST = "market/FETCH_ALL_PRODUCTS_REQUEST";
export const FETCH_ALL_PRODUCTS_SUCCESS = "market/FETCH_ALL_PRODUCTS_SUCCESS";
export const FETCH_ALL_PRODUCTS_FAILURE = "market/FETCH_ALL_PRODUCTS_FAILURE";

export const FETCH_ALL_CATEGORY_REQUEST = "market/FETCH_ALL_CATEGORY_REQUEST";
export const FETCH_ALL_CATEGORY_SUCCESS = "market/FETCH_ALL_CATEGORY_SUCCESS";
export const FETCH_ALL_CATEGORY_FAILURE = "market/FETCH_ALL_CATEGORY_FAILURE";


// Branch
export const CREATE_BRANCH_REQUEST = "branch/CREATE_REQUEST";
export const CREATE_BRANCH_SUCCESS = "branch/CREATE_SUCCESS";
export const CREATE_BRANCH_FAILURE = "branch/CREATE_FAILURE";

export const FETCH_BRANCHES_REQUEST = "branch/FETCH_BRANCHES_REQUEST";
export const FETCH_BRANCHES_SUCCESS = "branch/FETCH_BRANCHES_SUCCESS";
export const FETCH_BRANCHES_FAILURE = "branch/FETCH_BRANCHES_FAILURE";

export const EDIT_BRANCH_REQUEST = "branch/EDIT_BRANCH_REQUEST";
export const EDIT_BRANCH_SUCCESS = "branch/EDIT_BRANCH_SUCCESS";
export const EDIT_BRANCH_FAILURE = "branch/EDIT_BRANCH_FAILURE";

export const DELETE_BRANCH_REQUEST = "branch/DELETE_BRANCH_REQUEST";
export const DELETE_BRANCH_SUCCESS = "branch/DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAILURE = "branch/DELETE_BRANCH_FAILURE";

// User
export const FETCH_ALL_USERS_REQUEST = "user/FETCH_ALL_USERS_REQUEST";
export const FETCH_ALL_USERS_SUCCESS = "user/FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILURE = "user/FETCH_ALL_USERS_FAILURE";

export const UPDATE_USER_REQUEST = "user/UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "user/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "user/UPDATE_USER_FAILURE";

// Court
export const FETCH_ALL_COURTS_REQUEST = "courts/FETCH_ALL_COURTS_REQUEST";
export const FETCH_ALL_COURTS_SUCCESS = "courts/FETCH_ALL_COURTS_SUCCESS";
export const FETCH_ALL_COURTS_FAILURE = "courts/FETCH_ALL_COURTS_FAILURE";

export const CREATE_COURT_REQUEST = "courts/CREATE_COURT_REQUEST";
export const CREATE_COURT_SUCCESS = "courts/CREATE_COURT_SUCCESS";
export const CREATE_COURT_FAILURE = "courts/CREATE_COURT_FAILURE";

export const EDIT_COURT_REQUEST = "courts/EDIT_COURT_REQUEST";
export const EDIT_COURT_SUCCESS = "courts/EDIT_COURT_SUCCESS";
export const EDIT_COURT_FAILURE = "courts/EDIT_COURT_FAILURE";

export const DELETE_COURT_REQUEST = "courts/DELETE_COURT_REQUEST";
export const DELETE_COURT_SUCCESS = "courts/DELETE_COURT_SUCCESS";
export const DELETE_COURT_FAILURE = "courts/DELETE_COURT_FAILURE";

export const FETCH_AVAILABLE_COURTS_REQUEST =
  "courts/FETCH_AVAILABLE_COURTS_REQUEST";
export const FETCH_AVAILABLE_COURTS_SUCCESS =
  "courts/FETCH_AVAILABLE_COURTS_SUCCESS";
export const FETCH_AVAILABLE_COURTS_FAILURE =
  "courts/FETCH_AVAILABLE_COURTS_FAILURE";

// Booking
export const FETCH_ALL_BOOKINGS_REQUEST = "bookings/FETCH_ALL_BOOKINGS_REQUEST";
export const FETCH_ALL_BOOKINGS_SUCCESS = "bookings/FETCH_ALL_BOOKINGS_SUCCESS";
export const FETCH_ALL_BOOKINGS_FAILURE = "bookings/FETCH_ALL_BOOKINGS_FAILURE";

export const CREATE_BOOKING_REQUEST = "bookings/CREATE_BOOKING_REQUEST";
export const CREATE_BOOKING_SUCCESS = "bookings/CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_FAILURE = "bookings/CREATE_BOOKING_FAILURE";

export const EDIT_BOOKING_REQUEST = "bookings/EDIT_BOOKING_REQUEST";
export const EDIT_BOOKING_SUCCESS = "bookings/EDIT_BOOKING_SUCCESS";
export const EDIT_BOOKING_FAILURE = "bookings/EDIT_BOOKING_FAILURE";

export const DELETE_BOOKING_REQUEST = "bookings/DELETE_BOOKING_REQUEST";
export const DELETE_BOOKING_SUCCESS = "bookings/DELETE_BOOKING_SUCCESS";
export const DELETE_BOOKING_FAILURE = "bookings/DELETE_BOOKING_FAILURE";

export const SET_BOOKING_BRANCH = "booking/set_booking_branch";
export const SET_BOOKING_DATE = "booking/set_booking_date";
export const SET_BOOKING_TIME = "booking/set_booking_time";
export const SET_BOOKING_USERID = "booking/set_booking_userId";
export const SET_SHARE_BOOKING = "booking/set_share_booking";
export const SET_SHARE_BOOKING_DATA = "booking/set_share_booking_data";
export const CLEAR_BOOKING_DATA = "booking/clear_booking_data";

export const PREPARE_BOOKING_BRANCH = "booking/prepare_booking_branch";
export const PREPARE_BOOKING_COURTS = "booking/prepare_booking_courts";

export const GET_USER_BOOKING_HISTORY = "booking/get_user_booking_history";

export const SET_LOADING_STATE = "loading/set_loading_state";
export const RESET_LOADING_STATE = "loading/reset_loading_state";
export const CHNAGE_LANGUAGE = "app/change_language";